<template>
  <body class="sidebar-mini sidebar-collapse" :class="skin" style="height: 100%">
    <div id="app">
      <router-view />
    </div>
  </body>
</template>

<script>
export default {
  name: 'App',
  computed: {
    skin() {
      return this.$store.state.app.skin || 'skin-blue'
    }
  }
}
</script>

<style>
</style>
